const keys = {
    PRODUTO: '61cd2732ad47e0a02eab67e3',
    PROVIDER: '61cd2730ad47e0a02eab67da',
    TRANSPORTADORA: '626c0fd9e729a1df99297052',
    ESTABELECIMENTOS: '61cd2730ad47e0a02eab67d9',
    LOCAL_ESCRITURACAO: '61cd272fad47e0a02eab67d5',
}

export default keys;